type RewardDisplayItem = {
  reward: string;
  flex: boolean;
};

export const getRewardsToDisplay = (rewards?: string[]): RewardDisplayItem[] => {
  if (!rewards || rewards.length === 0) {
    return [];
  }

  if (rewards.length <= 2) {
    return rewards.map((reward) => ({ reward, flex: true }));
  }

  return [
    { reward: rewards[0], flex: true },
    { reward: `+ ${rewards.length - 1}`, flex: false },
  ];
};
